"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeveloper = void 0;
var Yup = __importStar(require("yup"));
var i18n_1 = __importDefault(require("../../i18n"));
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var apartmentInfo = function (apartmentId) {
    return {
        apartment_info: Yup.array().of(Yup.object().shape({
            sub_building: Yup.string().validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            floor: Yup.string()
                .nullable()
                .validateDeveloperApartmentByStructureType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), [GeneralSettings_1.PROPERTY_TYPES.COMMERCIAL, GeneralSettings_1.PROPERTY_TYPES.APARTMENT], apartmentId),
            rooms: Yup.string()
                .nullable()
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            area: Yup.number()
                .positive()
                .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            price: Yup.number()
                .positive()
                .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            currency: Yup.string().validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            apt_number: Yup.string()
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId)
                .max(5, i18n_1.default.t('common:ERROR_MESSAGES.TOO_MANY_SYMBOLS')),
            availability: Yup.string()
                .nullable()
                .validateDeveloperApartmentAvailability(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), GeneralSettings_1.DEAL_TYPES.SELL, apartmentId),
            apartment_plan: Yup.object()
                .nullable()
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            floor_plan: Yup.object()
                .nullable()
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
            building_plan: Yup.object()
                .nullable()
                .validateCurrentApartment(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), apartmentId),
        })),
    };
};
var developerSchema = {
    property_info: Yup.object().shape({
        address_picker: Yup.object().addressPicker(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
    }),
    about_building: Yup.object().shape({
        building_name: Yup.string().requiredByDealType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), GeneralSettings_1.DEAL_TYPES.SELL),
        construction_start: Yup.string()
            .nullable()
            .requiredByDealType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), GeneralSettings_1.DEAL_TYPES.SELL),
        construction_end: Yup.string()
            .nullable()
            .requiredByDealType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), GeneralSettings_1.DEAL_TYPES.SELL),
        building_area: Yup.number()
            .positive()
            .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD')),
        building_floors: Yup.number()
            .positive()
            .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
            .required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        media: Yup.array().requiredBuildingPicture(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        apartment_quantity: Yup.number()
            .positive()
            .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
            .required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
    }),
    mortgage: Yup.array().of(Yup.object().shape({
        name: Yup.string().when('is_exclusive', {
            is: function (is_exclusive) {
                return is_exclusive && is_exclusive[0] === 'is_available';
            },
            then: Yup.string().required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        }),
        min_prepayment: Yup.string().when(['name', 'is_exclusive'], {
            is: function (name, is_exclusive) {
                return (!!name ||
                    (is_exclusive && is_exclusive[0] === 'is_available'));
            },
            then: Yup.string().required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        }),
        min_percent: Yup.string().when(['name', 'is_exclusive'], {
            is: function (name, is_exclusive) {
                return (!!name ||
                    (is_exclusive && is_exclusive[0] === 'is_available'));
            },
            then: Yup.string().required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        }),
        max_duration: Yup.string().when(['name', 'is_exclusive'], {
            is: function (name, is_exclusive) {
                return (!!name ||
                    (is_exclusive && is_exclusive[0] === 'is_available'));
            },
            then: Yup.string().required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        }),
    })),
    contact: Yup.object({
        contacts: Yup.array()
            .of(Yup.object().shape({
            phone: Yup.string().armPhone(i18n_1.default.t('common:ERROR_MESSAGES.INVALID_ARM_PHONE')),
        }))
            .unique(i18n_1.default.t('common:ERROR_MESSAGES.DUPLICATE_PHONE'), 'contact.contacts', 'phone')
            .requiredAtLeastOnePhoneNumber(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRE_AT_LEAST_ONE_PHONE_NUMBER')),
    }),
    acceptTerms: Yup.bool().oneOf([true], i18n_1.default.t('common:ERROR_MESSAGES.READ_OUR_CONDITIONS')),
};
var getDeveloper = function (isApartmentFormSubmitted, collapsedApartmentId, publishedAt, isSaveButtonClicked) {
    if (isApartmentFormSubmitted && publishedAt) {
        return __assign({}, apartmentInfo(collapsedApartmentId));
    }
    if (collapsedApartmentId && !isApartmentFormSubmitted) {
        return __assign(__assign({}, developerSchema), apartmentInfo(collapsedApartmentId));
    }
    if (isSaveButtonClicked) {
        return developerSchema;
    }
};
exports.getDeveloper = getDeveloper;
